import React from 'react';
import { canonicalFor, usePageMeta } from '../../hooks/usePageMeta';
import { PageHeader } from '../../components/page/PageHeader';
import { ContentSection } from '../../components/page/ContentSection';
import { CatalogTable } from '../../components/page/CatalogTable';
import { CautionNote } from '../../components/page/CautionNote';
import { SalesCallout } from '../../components/page/SalesCallout';
import { RelatedLinks } from '../../components/page/RelatedLinks';
import { catalog, insertFamilies } from '../../data/catalog';
export function Inserts() {
  usePageMeta({
    title: 'APGX Inserts & Chipbreakers: MG12 and DR80 | Robertson Precision',
    description: 'Seven Shear Geometry APGX inserts: MG12 roughing, MG12 -30R chipbreakers and DR80 honed, MAX-coated inserts for titanium, with grade and nose radius. Sold in boxes of 10.',
    canonical: canonicalFor('/products/inserts/')
  });
  return <>
      <PageHeader eyebrow="Products" title="Inserts & Chipbreakers" lead="Seven APGX inserts in three families: MG12 roughing inserts for heavier feeds, MG12 -30R chipbreakers for lighter feed rates in aluminum, and DR80 honed, MAX-coated inserts for titanium. Inserts are sold in full boxes of 10." crumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Products',
      href: '/products/'
    }, {
      label: 'Inserts & Chipbreakers'
    }]} data-id="element-792" data-mp="1pnp77254zi07" />

      <ContentSection id="grades" data-id="element-793" data-mp="2huk1k19gy4nq">
        <CautionNote title="MG12 and DR80 are different grades" data-id="element-794" data-mp="2hxptdo9hfkn5">
          <p data-id="element-795" data-mp="2dti4nr30y4ox">
            The part-number families overlap — APGX 331R and APGX 332R exist in
            both Grade MG12 and DR80 — but the grades are different. Always
            state the full part number, including DR80 where applicable, when
            you order.
          </p>
        </CautionNote>
      </ContentSection>

      {insertFamilies.map((family, i) => <ContentSection key={family.id} id={family.id} tone={i % 2 === 0 ? 'warm' : 'white'} title={family.title} intro={<p data-id="element-797" data-mp="2slj6797f9mmf">{family.use}</p>} data-id="element-796" data-mp="shqdzpf9syz2" data-mpi={i}>
          <CatalogTable rows={catalog.filter(c => c.family === family.id)} caption={family.title} variant="inserts" data-id="element-798" data-mp="2xhhqaklpwih1" />
        </ContentSection>)}

      <ContentSection id="order-inserts" data-id="element-799" data-mp="36j7oqae0ohob">
        <SalesCallout location="inserts" note="Inserts are sold in full boxes of 10. Sales confirms pricing, availability and fit." data-id="element-800" data-mp="36guyl9y3v106" />
      </ContentSection>

      <RelatedLinks links={[{
      label: 'Aluminum',
      href: '/applications/aluminum/',
      description: 'MG12 roughing and -30R chipbreaker guidance.'
    }, {
      label: 'Titanium',
      href: '/applications/titanium/',
      description: 'DR80 starting range.'
    }, {
      label: 'Starting Data',
      href: '/technical-resources/starting-data/',
      description: 'All published starting values.'
    }, {
      label: 'Tool Holders',
      href: '/products/holders/',
      description: 'SALXR 16-3D and SALXR 12-3B.'
    }]} data-id="element-801" data-mp="3gfkj7ahdyzk4" />
    </>;
}